import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

export const SeriesCollections = () => {
  const [series, setSeries] = useState([]);
  useEffect(() => { api.get("/sermons/series").then(({ data }) => setSeries(data)).catch(() => {}); }, []);
  if (!series.length) return null;
  return (
    <div data-testid="series-collections">
      <h2 className="font-head text-lg font-bold flex items-center gap-2 mb-3"><Layers className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Series</h2>
      <div className="flex gap-4 overflow-x-auto pb-2 snap-x">
        {series.map((s) => {
          const thumb = s.thumbnail_url || (s.youtube_video_id ? `https://i.ytimg.com/vi/${s.youtube_video_id}/hqdefault.jpg` : "");
          const pct = s.count ? Math.round((s.watched / s.count) * 100) : 0;
          return (
            <Link key={s.name} to={`/sermons/series/${encodeURIComponent(s.name)}`} data-testid={`series-card-${s.name}`}
              className="snap-start shrink-0 w-64 bg-white rounded-2xl border border-[#EBE9E4] overflow-hidden hover:-translate-y-0.5 transition-transform">
              <div className="relative aspect-video" style={{ background: "var(--sj-primary)" }}>
                {thumb && <img src={thumb} alt="" className="absolute inset-0 w-full h-full object-cover" />}
                <span className="absolute bottom-2 left-2 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-black/70 text-white">{s.count} part{s.count === 1 ? "" : "s"}</span>
              </div>
              <div className="p-4">
                <div className="font-head font-bold leading-tight truncate">{s.name}</div>
                {s.speaker && <div className="text-xs truncate mt-0.5" style={{ color: "var(--sj-text-3)" }}>{s.speaker}</div>}
                <div className="mt-3 h-1.5 rounded-full bg-[#EDF2F4] overflow-hidden"><div className="h-full rounded-full" style={{ width: `${pct}%`, background: "var(--sj-secondary)" }} /></div>
                <div className="text-xs mt-1.5 flex items-center gap-1" style={{ color: "var(--sj-text-2)" }} data-testid={`series-progress-${s.name}`}>
                  {s.watched === s.count && <CheckCircle2 className="h-3.5 w-3.5" style={{ color: "var(--sj-secondary)" }} />} {s.watched} of {s.count} watched
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
